import React from 'react';
import { FaSignOutAlt } from "react-icons/fa";
import Popup from "reactjs-popup";
import Waring from "../../assets/img/warning.png";
import { useMsal } from "@azure/msal-react";

const contentStyle = {
  maxWidth: "300px",
  width: "100%",
  background: "white",
  borderRadius: "20px"
};
// Basic component with logout button




const Logout = () => {
  const { instance } = useMsal();

  const logout = async () => {
    // Will redirect to MSAL to end the session then redirect back to the configured `postLogoutRedirectUri`
    try {
      // Sign out the user
      await instance.logoutRedirect({
        postLogoutRedirectUri: `${process.env.REACT_APP_SSO_LOGOUT_REDIRECT_URL}`, // Replace with your redirect URI
        
      });
      localStorage.clear();
      window.location.href = `${process.env.REACT_APP_SSO_LOGOUT_REDIRECT_URL}`;
    } catch (error) {
      console.error("Logout failed", error);
    }
  };


  return (
    <>


      <Popup
        trigger={<button style={{ display: "contents", gridGap: "1rem" }} className="items_menu logoutCss">
          <div className="items_menu logoutCss">
            <div>
              <FaSignOutAlt fontSize={28} />
            </div>
            <div style={{paddingLeft:"10px"}} className="item_menuText">
              Logout
            </div>
          </div>
        </button>}
        modal
        contentStyle={contentStyle}
      >
        {close => (
          <div style={{ display: "contents", height: "auto", textAlign: "center", fontSize: "20px", padding: "1rem" }} className="modal">
            <a style={{ right: "4px", top: "7px", textDecoration: "none", background: "transparent" }} className="close" onClick={close}>
              &times;
            </a>
            <div className="header">
              <img width={64} src={Waring} alt="warnning" />
              <div style={{ textAlign: "center", color: "white", fontSize: "20px", fontWeight: "600", paddingTop: "5px" }}>WARNING</div>
              <div style={{ height: "auto", textAlign: "center", fontSize: "16px", paddingTop: "10px", fontWeight: "normal" }}>
                Do you want to logout?
              </div>
            </div>
            <div style={{ background: "white" }} className="actions">


              <button style={{ margin: "10px 15px", background: "#0000a0", border: "none", borderRadius: "2px", color: "white", paddingTop: "4px", paddingBottom: "4px" }}
                className="submit_btn btn_logout"
                onClick={() => {
                  logout();
                }}
              >
                Yes
              </button>

              <button style={{ margin: "10px 15px", background: "#d1d3d5", border: "none", borderRadius: "2px", color: "white", paddingTop: "4px", paddingBottom: "4px" }}
                className="cancel_btn btn_logout"
                onClick={() => {
                  close();
                }}
              >
                No
              </button>
            </div>
          </div>
        )}
      </Popup>
    </>
  );
};

export default Logout;